import { TemplateCollectionsQuery } from '@app/queries/TemplateCollections/TemplateCollections.queries'

export const sortTemplateCollections = (
  collections: TemplateCollectionsQuery['templateCollections']
) => {
  const sortedCollections = collections.items.sort((a, b) => {
    return a.uid.localeCompare(b.uid)
  })

  const sortedTemplates = sortedCollections.map((collection) => {
    const sorted = (collection.templates || []).sort((a, b) => {
      return a.uid.localeCompare(b.uid)
    })

    return {
      ...collection,
      templates: sorted
    }
  })

  return sortedTemplates
}
